import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';

const ROUTER_DEFINITION: Routes = [
  // { path: '', redirectTo: 'page-not-found', pathMatch: 'full' },
  // Main-Pages
  {
    path: 'main-pages',
    loadChildren: () => import('./function-modules/main-pages/main-pages.module').then(m => m.MainPagesModule)
  },
  { path: '**', component: PageNotFoundComponent, data: { animation: '99' } }
];

@NgModule({
  imports: [RouterModule.forRoot(ROUTER_DEFINITION, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }